export default __webpack_public_path__ + "img/86b6a0e6e535c37f50113f550378812d.png";